export default __webpack_public_path__ + "static/american-flag-5f59b34b3732fb9fa718ef0ac5cdb21d.jpg";